import React, {useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import {makeStyles, Typography} from "@material-ui/core";
import Form from "components/Form";
import useId from "hooks/useId";
import * as Yup from "yup";
import VS from "constants/ValidationShema";
import DateTimePicker from "components/DateTimePicker";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {connect} from "react-redux";
import moment from "libs/moment";
import AdditionalRoundService from "services/AdditionalRoundService";

const useStyle = makeStyles(theme => ({
    dateTimePicker: {
        width: 350
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    }
}));

const OfferChoiceEditAdditionalRoundsDatesPopup = (
    {
        demandId,
        roundName,
        additionalRoundId,
        additionalRoundStatus,
        additionalRoundEndDate,
        additionalRoundOpenOfferDate,
        onCancel,
        onSuccess,
        formSubmit
    }) => {
    const classes = useStyle();
    const [working, setWorking] = useState(false);
    const [error, setError] = useState(false);
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = (values) => {
        setError(false);
        setWorking(true);
        AdditionalRoundService.changeDates(demandId, values).then(() => onSuccess(values)).catch(() => {
            setError(true);
            setWorking(false);
        })
    }


    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel, 'outlined', working));
        buttons.push(createButton(Tr('change_dates'), handleSubmit, undefined, working));
        return buttons;
    }

    const handleEndDate = (formikProps, value) => {
        formikProps.setFieldValue('openOfferDate', value);
    }

    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            title={Tr('edit_dates_popup_title')}
            maxWidth='sm'
        >
            <GridBlock
                column
            >
                {working && <Loading/>}
                {error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{Tr('unknown_error_message')}</TypographyWithIcon>}

                <Form
                    initialValues={{
                        roundId: additionalRoundId,
                        endDate: moment(additionalRoundEndDate),
                        openOfferDate: moment(additionalRoundOpenOfferDate)
                    }}
                    validationSchema={Yup.object().shape({
                        endDate: VS.dateTimeMin(new Date(), Tr('v_time_can_not_be_past')),
                        openOfferDate: VS.dateTimeValid()
                            .when('endDate', (endDate, schema) => {
                                return schema.test('EndDateLessOpenDate', Tr("EndDateLessOpenDate"), (offerOpenDate) => {
                                    if (endDate && offerOpenDate) {
                                        return !offerOpenDate.isBefore(endDate);
                                    }
                                    return false;
                                })
                            })
                    })}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <GridBlock
                            column
                        >
                            <Typography className={classes.marginBottom} variant="h6">
                                {roundName}
                            </Typography>
                            <DateTimePicker
                                className={classes.dateTimePicker}
                                id='endDate'
                                label={Tr('additional_round_end_date')}
                                formikProps={formikProps}
                                disabled={working}
                                onChange={(value) => handleEndDate(formikProps, value)}
                                minDate={new Date()}
                            />

                            <DateTimePicker
                                className={classes.dateTimePicker}
                                id='openOfferDate'
                                label={Tr('additional_round_open_offer_date')}
                                formikProps={formikProps}
                                disabled={working}
                                minDate={new Date()}
                            />

                        </GridBlock>
                    )}
                </Form>
            </GridBlock>
        </Dialog>)
}

OfferChoiceEditAdditionalRoundsDatesPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    roundName: PropTypes.string.isRequired,
    additionalRoundId: PropTypes.number.isRequired,
    additionalRoundStatus: PropTypes.string.isRequired,
    additionalRoundEndDate: PropTypes.string.isRequired,
    additionalRoundOpenOfferDate: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(OfferChoiceEditAdditionalRoundsDatesPopup)